const aiSimulationTypes = {
  RESET_AI_SIMULATION_STATE: 'RESET_AI_SIMULATION_STATE',
  DISCARD_AI_SIMULATION: 'DISCARD_AI_SIMULATION',
  CLEAR_AI_SIMULATION_ERROR: 'CLEAR_AI_SIMULATION_ERROR',

  START_AI_SIMULATION: {
    REQUEST: 'START_AI_SIMULATION.REQUEST',
    SUCCESS: 'START_AI_SIMULATION.SUCCESS',
    FAILURE: 'START_AI_SIMULATION.FAILURE',
  },

  REPLY_AI_SIMULATION: {
    REQUEST: 'REPLY_AI_SIMULATION.REQUEST',
    SUCCESS: 'REPLY_AI_SIMULATION.SUCCESS',
    FAILURE: 'REPLY_AI_SIMULATION.FAILURE',
  },

  ADVANCE_AI_SIMULATION: {
    REQUEST: 'ADVANCE_AI_SIMULATION.REQUEST',
    SUCCESS: 'ADVANCE_AI_SIMULATION.SUCCESS',
    FAILURE: 'ADVANCE_AI_SIMULATION.FAILURE',
  },
};

export default aiSimulationTypes;
